/** True when this page is rendered inside another page's frame (any origin). */
export function isEmbeddedInIframe(): boolean {
  return window.self !== window.top
}
